export const TRACKING_URL = 'https://spotandtango.aftership.com';
